// Client V2 common imports
const createEmptyMessage = require('client-v2/common/containers/feed/empty-message')
const { defaultFeedSelectors } = require('client-v2/common/containers/feed/selectors')

const EmptyPostsMessage = createEmptyMessage(props => {
  const { username } = props.collection
  return `@${username} hasn't posted any content in this Collection yet.`
})

const EmptySelfPostsMessage = createEmptyMessage(() => {
  return `You haven't posted any content in this Collection yet.`
})

const EmptySubscribersMessage = createEmptyMessage(() => {
  return `No one is subscribed to this Collection yet.`
})

function emptyMessageState(state) {
  const isSelfProfile = state.collection['user_id'] === state.user.id
  const items = defaultFeedSelectors.getDenormalizedItems(state)
  if (items.size) {
    return null
  }
  switch (state.router.action) {
    case 'collection-profile.showPosts':
      return isSelfProfile ? EmptySelfPostsMessage : EmptyPostsMessage
    case 'collection-profile.showSubscribers':
      return EmptySubscribersMessage
  }
}

module.exports = Object.assign({}, defaultFeedSelectors, {
  emptyMessageState
})
